<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useI18n } from 'vue-i18n';
import SettingsSectionCard from 'dashboard/components-next/Settings/SettingsSectionCard.vue';

const { t } = useI18n();
const { currentAccount } = useAccount();

const getAccountId = computed(() => currentAccount.value.id.toString());
</script>

<template>
  <SettingsSectionCard
    :title="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.NOTE')"
  >
    <woot-code :script="getAccountId" />
  </SettingsSectionCard>
</template>
